// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LK3UR{width:264px;height:232px;padding:24px 24px 0 24px;display:flex;flex-direction:column;justify-content:space-between}.OGjQb{padding:0 24px;min-height:64px}.WWUmj{padding:0 24px;text-align:center}.c7VhJ{height:68px;padding-bottom:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `LK3UR`,
	"icon": `OGjQb`,
	"text": `WWUmj`,
	"bottom": `c7VhJ`
};
export default ___CSS_LOADER_EXPORT___;
